import App from './app.js';

new App("/api/routes/", "/api/route/");